import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { AppointmentType } from 'constants/appointmentType'
import { hydratePathname } from '../../../../util'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'

const ApiPathname = {
  RESOURCE_APPOINTMENT_TYPES: '/api/:apiVersion/resources/:resourceId/appointment-types',
} as const

const makeGetResourceAppointmentTypes =
  (baseUrl: string, config: HttpClientConfig) =>
  async (resourceId: string): Promise<Record<DeliveryModel, AppointmentType[]>> => {
    const pathname = hydratePathname(ApiPathname.RESOURCE_APPOINTMENT_TYPES, {
      apiVersion,
      resourceId,
    })

    const { data } = await service(baseUrl).get<Record<DeliveryModel, AppointmentType[]>>(pathname, config)

    return data
  }

export { makeGetResourceAppointmentTypes }
